import { lazy } from 'react'

export const AddingReleaseStep3Page = lazy(() => import('./AddingReleaseStep3Page'))
